import React from "react";
import { string } from "prop-types";
import { StyleSheet, css } from "aphrodite";

function DetailMemberNameComponent(props) {
  const { name } = props;
  return <h3 className={css(styles.detailName)}> {name} </h3>;
}

DetailMemberNameComponent.propTypes = {
  name: string,
};

const styles = StyleSheet.create({
  detailName: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: 800,
    color: "#495057",
    marginTop: 10
  },
});

export default DetailMemberNameComponent;
